import React, { Component, MouseEvent } from "react";
import classnames from "classnames";

import { Fader } from "@formant/ui/component/common/Fader";

import { Escape } from "./Escape";
import { FlexSpacer } from "./FlexSpacer";
import { Heading3 } from "./Heading3";
import { IconButton } from "./IconButton";
import * as styles from "./Popup.scss";

export interface IPopupProps {
    visible: boolean;
    className?: string;
    windowClassName?: string;
    containerClassName?: string;
    faderClassName?: string;
    onClose?: () => void;
    hasClosed?: () => void;
    children?: React.ReactNode;
    title?: string;
    flip?: boolean;
    slide?: boolean;
    variant?: "dark" | "light";
}

export class Popup extends Component<IPopupProps> {
    public render() {
        const {
            visible,
            className,
            windowClassName,
            containerClassName,
            faderClassName,
            children,
            hasClosed,
            onClose,
            title,
            flip,
            slide,
            variant,
        } = this.props;

        return (
            <Fader
                visible={visible}
                hasClosed={hasClosed}
                visibleClassName={faderClassName}
                className={classnames(
                    styles.popup,
                    className,
                    flip === true && styles.flip,
                    styles.flipped,
                    slide === true && styles.slide,
                )}
            >
                {onClose && <Escape onEsc={onClose} />}
                <div
                    className={classnames(styles.container, containerClassName)}
                    onMouseDown={onClose}
                >
                    <FlexSpacer className={styles.spacer} />
                    <div className={styles.wrapper}>
                        <div
                            className={classnames(
                                styles.window,
                                variant === "light" && styles.lighter,
                                variant === "dark" && styles.dark,
                                windowClassName,
                                title && styles.withTitle,
                            )}
                            onMouseDown={this.onMouseDown}
                        >
                            {children}
                            {title && (
                                <Heading3 className={styles.title}>
                                    {title}
                                </Heading3>
                            )}
                            {onClose && (
                                <IconButton
                                    icon="close"
                                    className={styles.close}
                                    onClicked={onClose}
                                />
                            )}
                        </div>
                    </div>
                    <FlexSpacer className={styles.spacer} />
                </div>
            </Fader>
        );
    }

    private onMouseDown = (event: MouseEvent) => {
        event.stopPropagation();
    };
}
